module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lee-progress lee-panel"
  }, [_c('div', {
    staticClass: "heading justify-between"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "list progress-content"
  }, _vm._l((_vm.progressData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "progress"
    }, [_c('el-progress', {
      attrs: {
        "text-inside": true,
        "stroke-width": 13,
        "percentage": item.value,
        "status": _vm.judgeStatus(item.value)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, _vm._l((item.tags), function(tag) {
      return _c('el-tag', {
        key: tag.id,
        staticClass: "tag",
        attrs: {
          "type": "primary"
        }
      }, [_vm._v(_vm._s(tag))])
    })), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('span', [_vm._v(_vm._s(item.name))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dae406a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress.vue
// module id = 609
// module chunks = 1